import { render } from "./IshurMachalaM.vue?vue&type=template&id=20ea999d&scoped=true"
import script from "./IshurMachalaM.vue?vue&type=script&lang=js"
export * from "./IshurMachalaM.vue?vue&type=script&lang=js"

import "./IshurMachalaM.vue?vue&type=style&index=0&id=20ea999d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ea999d"]])

export default __exports__